import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '@/shared/contexts/AuthContext'
import { updateProfile } from '@/modules/profile'

export type Theme = 'light' | 'dark'

function applyTheme(theme: Theme) {
  localStorage.setItem('theme', theme)
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

export function useThemeState() {
  const [theme, setTheme] = useState<Theme>('light')
  const [mounted, setMounted] = useState(false)
  const { user } = useAuth()

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as Theme | null

    if (savedTheme === 'light' || savedTheme === 'dark') {
      setTheme(savedTheme)
      document.documentElement.classList.toggle('dark', savedTheme === 'dark')
    }

    setMounted(true)
  }, [])

  const toggleTheme = useCallback(async () => {
    const nextTheme: Theme = theme === 'light' ? 'dark' : 'light'

    setTheme(nextTheme)
    applyTheme(nextTheme)

    try {
      if (user?.id) {
        await updateProfile(user.id, { theme: nextTheme })
      }
    } catch (error) {
      console.error('[useThemeState] Error saving theme:', error)
    }
  }, [theme, user?.id])

  return {
    theme,
    mounted,
    toggleTheme,
  }
}